import { render, staticRenderFns } from "./e-browser-icon.vue?vue&type=template&id=844eabba&scoped=true"
import script from "./e-browser-icon.vue?vue&type=script&lang=js"
export * from "./e-browser-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844eabba",
  null
  
)

export default component.exports